import Form from './form.vue';
import AssociatTerminal from '../components/terminal/associat.vue';
import AddressManage from '../components/addressManage';
import CustomerPortrait from '../components/customer_portrait/index.vue';

export {
  Form, AssociatTerminal, AddressManage, CustomerPortrait,
};
